const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 官方对象类型内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_hash.html
 * @author Caesar Liu
 * @date 2020-11-20 14:58
 */
module.exports = [
  buildConfig('keys', {
    documentation: [
      '返回数组，包含对象中所有的key',
      'e.g: ',
      '<#assign h = {"name":"mouse", "price":50}>',
      '<#assign keys = h?keys>',
      '<#list keys as key>${key} = ${h[key]}; </#list>',
      '结果输出',
      'name = mouse; price = 50;'
    ].join('\n')
  }),
  buildConfig('values', {
    documentation: [
      '返回数组，包含对象中所有的value',
      'e.g: ',
      '<#assign h = {"name":"mouse", "price":50}>',
      '<#assign values = h?values>',
      '<#list values as value>${value} </#list>',
      '结果输出',
      'mouse 50 '
    ].join('\n')
  })
]
